import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getFormValues } from 'redux-form';
import { bindActionCreators } from 'redux';
import { bindPromiseCreators } from 'redux-saga-routines';
import { hideModal } from 'erisxkit/client';
import { get } from 'lodash';
import {
  setUserToOnboardedPromiseCreator,
  skipFunding,
} from '../reducers/utilitiesReducer';
import CreateFundingPassword from '../components/CreateFundingPassword';
import {
  getCurrentAuthId,
  getLoggedInUser,
  fetchUser,
  fetchUserPromiseCreator,
  getIsRsbixUser,
} from '../reducers/userReducer';
import LoadingComponent from '../common/components/xtable/LoadingComponent';
import * as userStates from '../constants/userStates';
import { isOnboarding } from '../utils/methods';import { pushTag, trackEvent } from '../common/tracking';
import {
  createLinkedMemberBankAccountIraMember,
  iraBankMsgPromiseCreator,
} from '../reducers/linkedAccountsReducer';

const mapDispatchToProps = (dispatch) => ({
  ...bindPromiseCreators(
    {
      setUserToOnboardedPromiseCreator,
      fetchUserPromiseCreator,
      iraBankMsgPromiseCreator,
    },
    dispatch,
  ),
  ...bindActionCreators(
    {
      fetchUser,
      hideModal,
      skipFunding,
      createLinkedMemberBankAccountIraMember,
    },
    dispatch,
  ),
});

const mapStateToProps = (state) => ({
  authId: getCurrentAuthId(state),
  user: getLoggedInUser(state),
  isRsbixUser: getIsRsbixUser(state),
  values: getFormValues('funding_password')(state),
});

const storePasswordErrorMessage = {
  header: 'Password was not stored, please contact support.',
  content:
    'Alternatively you can choose to skip this step.  You will always be able to set this up after you are on-boarded.',
  type: 'warning',
};

class CreateFundingPasswordContainer extends Component {
  state = {
    setUserToOnboardedLoading: false,
    setUserToOnboardedFailed: false,
  };

  handleSubmit = () => {
    if (this.props.action !== 'reset') {
      trackEvent('accountOpening', 'fundingPasswordSubmit');
      pushTag('completeOnboarding');
    }

    this.setState({ setUserToOnboardedLoading: true });

    this.props.setUserToOnboardedPromiseCreator().then(
      (successPayload) => {
        if (successPayload.state === userStates.FUNDING_KEY_STORED) {
          this.setState({
            setUserToOnboardedLoading: false,
          });
        } else {
          this.setState({
            message: storePasswordErrorMessage,
            setUserToOnboardedLoading: false,
          });
        }
        this.props.hideModal();
      },
      () => {
        this.setState({
          message: storePasswordErrorMessage,
          setUserToOnboardedLoading: false,
          setUserToOnboardedFailed: true,
        });
      },
    );
  };

  render = () => {
    const pendingUserStates = [
      userStates.FUNDING_KEY_SKIPPED,
      userStates.FUNDING_KEY_STORED,
      userStates.PENDING_ACCOUNT,
      userStates.ACCOUNT_LINKED,
      userStates.EMARKET_ASSOCIATED,
      userStates.CQG_ASSOCIATED,
      userStates.PII_SUBMITTED,
    ];

    if (pendingUserStates.includes(this.props.user.state)) {
      return (
        <LoadingComponent
          action={this.props.fetchUser}
          message={{
            text: 'Please wait while we finish setting up your account...',
          }}
        />
      );
    }

    return (
      <CreateFundingPassword
        handleSubmit={this.handleSubmit}
        message={this.state.message}
        loading={this.state.setUserToOnboardedLoading}
        action={this.props.action}
        skipFunding={this.props.skipFunding}
        setUserToOnboardedFailed={this.state.setUserToOnboardedFailed}
        isOnboarding={isOnboarding(get(this.props, ['user', 'state']))}
      />
    );
  };
}

CreateFundingPasswordContainer.propTypes = {
  setUserToOnboardedPromiseCreator: PropTypes.func.isRequired,
  authId: PropTypes.string.isRequired,
  values: PropTypes.object,
};

CreateFundingPasswordContainer.defaultProps = {
  values: {},
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateFundingPasswordContainer);
